import {copilot} from '@cl/shared';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import adBuilderContext from 'common/src/modules/creativeTemplates/copilot/context/adBuilderContext';
import creativeTemplatePageContext from 'common/src/modules/creativeTemplates/copilot/context/creativeTemplatePageContext';
import creativeTemplatesLibraryContext from 'common/src/modules/creativeTemplates/copilot/context/creativeTemplatesLibraryContext';
import {CLStore} from 'common/src/redux/store';

function initializeCreativeTemplatesUiContexts(store: CLStore) {
  copilot.uiContexts.registerUiContexts(BreadcrumbName.CreativeTemplatesLibrary, {
    description:
      'The creative templates library lists all templates in the account with filtering and search.',
    contexts: [creativeTemplatesLibraryContext(store)],
  });

  copilot.uiContexts.registerUiContexts(BreadcrumbName.CreativeTemplatePage, {
    description:
      'This page shows a creative template\'s details including its formats and mapping configuration.',
    contexts: [creativeTemplatePageContext(store)],
  });

  copilot.uiContexts.registerUiContexts(BreadcrumbName.AdBuilder, {
    description:
      'The Ad Builder is a visual editor for composing ad creatives within a template format.',
    contexts: [adBuilderContext(store)],
  });
}

export default initializeCreativeTemplatesUiContexts;
